import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import LoginModal from './Login';
import logo from '../Assests/logo1.png';

const glassBar = css`
  backdrop-filter: blur(22px) saturate(180%) brightness(1.05);
  -webkit-backdrop-filter: blur(22px) saturate(180%) brightness(1.05);

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.18), rgba(255,255,255,0.06)) padding-box,
    linear-gradient(135deg, rgba(255,255,255,0.55), rgba(255,255,255,0.14)) border-box;

  box-shadow:
    0 14px 40px rgba(0,0,0,0.10),
    inset 0 1px 0 rgba(255,255,255,0.35);
`;

const glassPill = css`
  backdrop-filter: blur(18px) saturate(175%);
  -webkit-backdrop-filter: blur(18px) saturate(175%);

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.20), rgba(255,255,255,0.05)) padding-box,
    linear-gradient(135deg, rgba(255,255,255,0.55), rgba(255,255,255,0.12)) border-box;

  box-shadow:
    0 10px 30px rgba(0,0,0,0.08),
    inset 0 1px 0 rgba(255,255,255,0.30);
`;

const Navbar = ({ scrollToSection, refs, onPricingToggle }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleModal = () => setIsModalOpen((v) => !v);
  const toggleMenu = () => setIsMenuOpen((v) => !v);

  const go = (ref) => {
    setIsMenuOpen(false);
    scrollToSection(ref);
  };

  const handlePricingClick = () => {
    setIsMenuOpen(false);
    if (onPricingToggle) {
      onPricingToggle();
    }
  };

  return (
    <>
      <NavbarContainer>
        <LeftGroup>
          <BrandWrap>
            <BrandIcon src={logo} alt="eBaybayMo logo" />
            <Logo>eBaybayMo</Logo>
          </BrandWrap>
        </LeftGroup>


        <Hamburger onClick={toggleMenu} aria-label="Toggle menu" aria-expanded={isMenuOpen}>
          <Bar />
          <Bar />
          <Bar />
        </Hamburger>

        <NavLinks $isOpen={isMenuOpen}>
          <NavLink onClick={() => go(refs.heroRef)}>Home</NavLink>
          <NavLink onClick={handlePricingClick}>Pricing</NavLink>
          <NavLink onClick={() => go(refs.researchRef)}>Research</NavLink>
          <NavLink onClick={() => go(refs.aboutRef)}>About</NavLink>
          <NavLink onClick={() => go(refs.teamRef)}>Team Members</NavLink>

          <ButtonContainer>
            <LoginButton onClick={toggleModal}>Login</LoginButton>
          </ButtonContainer>
        </NavLinks>
      </NavbarContainer>

      <LoginModal isOpen={isModalOpen} toggleModal={toggleModal} />
    </>
  );
};

export default Navbar;

const NavbarContainer = styled.nav`
  ${glassBar}
  position: fixed;
  top: 12px;
  left: 12px;
  right: 12px;
  height: 72px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-radius: 18px;
  z-index: 1000;
  padding: 0 1rem;

  @media (max-width: 768px) {
    height: auto;
    padding: 0.85rem 0.9rem;
    flex-wrap: wrap;
    gap: 0.65rem;
  }
`;

const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.9rem;
`;

const Logo = styled.div`
  color: #a52a2a;
  font-size: 1.55rem;
  font-weight: 900;
  font-style: italic;
  letter-spacing: -0.02em;
  text-shadow: 0px 8px 22px rgba(0, 0, 0, 0.14);
  padding: 0.35rem 0.6rem;
  border-radius: 14px;
`;

const Hamburger = styled.button`
  display: none;
  background: transparent;
  border: 0;
  padding: 0.45rem;
  border-radius: 12px;
  cursor: pointer;

  @media (max-width: 768px) {
    display: inline-flex;
    flex-direction: column;
    gap: 6px;
  }
`;

const Bar = styled.span`
  width: 26px;
  height: 2.5px;
  background: rgba(40, 40, 40, 0.78);
  border-radius: 999px;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;

  @media (max-width: 768px) {
    width: 100%;
    display: ${(p) => (p.$isOpen ? 'flex' : 'none')};
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    padding-top: 0.4rem;
  }
`;

const NavLink = styled.button`
  ${glassPill}
  border-radius: 999px;
  cursor: pointer;

  color: rgba(20, 20, 20, 0.80);
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  font-size: 0.98rem;
  padding: 0.65rem 0.95rem;

  border: 1px solid transparent;
  transition: transform 0.16s ease, filter 0.16s ease;

  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.03);
  }

  &:active {
    transform: translateY(0px) scale(0.985);
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: left;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0.5rem;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const LoginButton = styled.button`
  ${glassPill}
  border-radius: 999px;
  cursor: pointer;

  color: #a52a2a;
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  font-size: 0.98rem;

  padding: 0.65rem 1.1rem;
  min-width: 110px;

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.18), rgba(255,255,255,0.05)) padding-box,
    linear-gradient(135deg, rgba(165,42,42,0.65), rgba(165,42,42,0.15)) border-box;

  transition: transform 0.16s ease, filter 0.16s ease;

  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.03);
  }

  &:active {
    transform: translateY(0px) scale(0.985);
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
  }
`;

const BrandWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

const BrandIcon = styled.img`
  width: 34px;
  height: 34px;
  object-fit: contain;
  border-radius: 10px;

  /* subtle glass chip behind the icon */
  padding: 4px;
  background: rgba(255,255,255,0.18);
  border: 1px solid rgba(255,255,255,0.22);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.25);
`;
